export default "__VITE_ASSET__e77c0179__"